import { Line2 } from './Line2';
import { Vector, Box2, Vector2 } from 'three';
import { Range } from './Range';

export class Box2Extensions
{
  static createFromPoints( a:Vector2, b:Vector2, extension:Vector2|number = undefined )
  {
    let min = a.clone().min( b );
    let max = b.clone().max( a );

    let box = new Box2( min, max );

    if ( extension != undefined )
    {
      if ( typeof extension === "number" )
      {
        box.expandByVector( new Vector2( 1, 1 ).multiplyScalar( extension ) );
      }
      else
      {
        box.expandByVector( extension );
      }
    }

    return box;
  }

  static info( box:Box2 )
  {
    let min = box.min;
    let max = box.max;

    return `{min:${min.x},${min.y} max:${max.x},${max.y}}`;
  }

  static getRangeX( box2:Box2 ):Range
  {
    return new Range( box2.min.x, box2.max.x );
  }

  static getRangeY( box2:Box2 ):Range
  {
    return new Range( box2.min.y, box2.max.y );
  }

  static fromPoints( points:Vector2[] ):Box2
  {
    let minX =   Number.MAX_VALUE;
    let maxX = - Number.MAX_VALUE;
    
    let minY =   Number.MAX_VALUE;
    let maxY = - Number.MAX_VALUE;

    for ( let point of points )
    {
      minX = Math.min( point.x, minX );
      minY = Math.min( point.y, minY );

      maxX = Math.min( point.x, maxX );
      maxY = Math.min( point.y, maxY );
    }

    return new Box2( new Vector2( minX, minY ), new Vector2( maxX, maxY ) );
  }

  static fromClientRect( clientRect:ClientRect|DOMRect )
  {
    let min = new Vector2( clientRect.left, clientRect.top );
    let max = new Vector2( clientRect.right, clientRect.bottom );
    
    return new Box2( min, max );
  }

  static updatefromClientRect( box:Box2, clientRect:ClientRect|DOMRect )
  {
    box.min.set( clientRect.left, clientRect.top );
    box.max.set( clientRect.right, clientRect.bottom );
  }

  static toDomRect( box:Box2 )
  {
    let size = box.getSize( new Vector2() );
    let domRect = new DOMRect( box.min.x, box.min.y, size.x, size.y );
    return domRect;
  }


  static updatefromElement( box:Box2, element:Element )
  {
    let boundingRect = element.getBoundingClientRect();
    Box2Extensions.updatefromClientRect( box, boundingRect );

    //console.log( "UpdateFromElement", element, ">>", boundingRect );
    
  }

  static getLines( box2:Box2 ):Line2[]
  {
    let lt = box2.min;
    let rt = new Vector2( box2.max.x, box2.min.y );
    let lb = new Vector2( box2.min.x, box2.max.y );
    let rb = box2.max;
    
    let lines = 
    [
      new Line2( lt, rt ),
      new Line2( rt, rb ),
      new Line2( rb, lb ),
      new Line2( lb, lt )
    ]

    return lines;
  }
}